import * as api from '../api';

export const fetchIntakeFormActions = api.fetchActions('intake', 'fetch-intake-form');
export const getFormActions = api.fetchActions('intake', 'get-form');
export const submitIntakeFormActions = api.fetchActions('intake', 'submit-form');

export const actionTypes = {
  ...fetchIntakeFormActions.actionTypes,
  ...getFormActions.actionTypes,
  ...submitIntakeFormActions.actionTypes,
};

export const fetchIntakeForm = (id) =>
  api.getThunk(`/intake/${id}`, {}, fetchIntakeFormActions, {id}, api.unauthorizedConfig);
export const getForm = (id) =>
  api.getThunk(`/intake/display-form/${id}`, {}, getFormActions, {id}, api.unauthorizedConfig);
export const submitIntakeForm = (id, answers, recaptchaResponse) =>
  api.postThunk(`/intake/save/${id}`, {id, answers, recaptchaResponse}, submitIntakeFormActions, {id}, api.unauthorizedConfig);



// WEBPACK FOOTER //
// src/intake/intake.actions.js